"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SignatureFieldValueGetter = void 0;
const safe_field_value_1 = require("../safe-field-value");
const get_value_1 = require("./get-value");
const signature_1 = require("../type-checking/signature");
class SignatureFieldValueGetter extends safe_field_value_1.BaseFieldValueGetter {
    constructor() {
        super(...arguments);
        this.isValidFieldValue = (fieldValue) => {
            return (0, signature_1.isSignatureFieldValue)(fieldValue);
        };
        this.getEmptyValue = () => (0, get_value_1.getSignatureFieldEmptyValue)();
    }
}
exports.SignatureFieldValueGetter = SignatureFieldValueGetter;
